export default "__VITE_ASSET__BTW7G_zk__"